import { render, staticRenderFns } from "./ContentBox.vue?vue&type=template&id=6ff40085&scoped=true&"
import script from "./ContentBox.vue?vue&type=script&lang=js&"
export * from "./ContentBox.vue?vue&type=script&lang=js&"
import style0 from "./ContentBox.vue?vue&type=style&index=0&id=6ff40085&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff40085",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})
